const dateFormatMixin = {
  methods: {
    formatDate: function(date, format = 'default') {
      if (!date) {
        return ''
      }

      format = date.indexOf('/') > -1 ? 'invert' : format

      let characterSplit = format == 'default' ? '-' : '/'
      let characterConcat = format == 'default' ? '/' : '-'

			let dateHora = date.split(' ');
			let dateFormat = dateHora[0].split(characterSplit);

			return dateFormat[2] + characterConcat + dateFormat[1] + characterConcat + dateFormat[0];
		},

    
    formatDateHour: function(date, format = 'default') {
      if (!date) {
        return ''
      }
  
      format = date.indexOf('/') > -1 ? 'invert' : format
  
      let characterSplit = format == 'default' ? '-' : '/'
      let characterConcat = format == 'default' ? '/' : '-'
  
      let dateHora = date.split(' ');
      let dateFormat = dateHora[0].split(characterSplit) 
  
      return (
        dateFormat[2] + characterConcat + dateFormat[1] + 
        characterConcat + dateFormat[0] + ' às ' + dateHora[1]
        )
    },
  },

  
  
}

export default dateFormatMixin
